"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: marqueeRef,
    isVisible: marqueeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const partners = [{
    name: "ECO-TEX",
    descriptor: "CERTIFIED SUSTAINABLE INKS"
  }, {
    name: "PREMIUM FILM",
    descriptor: "HIGH-DENSITY TRANSFER FILM"
  }, {
    name: "FAST-DRY",
    descriptor: "RAPID CURE TECHNOLOGY"
  }, {
    name: "VIBRANT-X",
    descriptor: "COLOR ACCURACY SYSTEMS"
  }, {
    name: "DURABLE-WEAR",
    descriptor: "WASH-TESTED ADHESIVES"
  }, {
    name: "PRECISION-HEAT",
    descriptor: "THERMAL PRESS CALIBRATION"
  }, {
    name: "GLOBAL-LOG",
    descriptor: "SECURE WORLDWIDE SHIPPING"
  }, {
    name: "BOUTIQUE-PRO",
    descriptor: "SMALL BATCH SPECIALISTS"
  }];
  const additionalPartners = ["COTTON-SOFT", "POLY-BLEND", "NYLON-TECH", "CANVAS-PRO", "DENIM-READY", "STRETCH-FIT", "UV-RESIST", "FADE-PROOF", "ECO-BASE", "BIO-FILM", "FAST-TURN", "CUSTOM-CUT"];
  return <section data-section-id="4967" id="sustainable-partners" className="bg-background text-foreground relative overflow-hidden py-24 md:py-30 px-4 md:px-8">
      <div className="pointer-events-none absolute top-6 left-6 flex items-center gap-2 font-mono text-[10px] tracking-widest text-secondary/40">
        <span className="inline-block h-px w-4 bg-secondary/30" />
        <span>SN/07</span>
      </div>
      <div className="pointer-events-none absolute top-6 right-6 font-mono text-[10px] tracking-widest text-secondary/40">
        SEC.07 / PARTNERS
      </div>

      <div className="relative mx-auto max-w-7xl">
        <div ref={headerRef} className={`text-center mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="font-mono text-[11px] tracking-[0.25em] text-secondary mb-6 flex items-center justify-center gap-3">
            <span className="inline-block h-px w-8 bg-border" />
            <span>§ PARTNERS / QUALITY STANDARDS</span>
            <span className="inline-block h-px w-8 bg-border" />
          </div>
          <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-6xl tracking-tighter text-foreground">
            Industry-leading quality standards.
          </h2>
          <p className="font-mono text-xs tracking-wider text-secondary/70 mt-6">
            VERIFIED / 08 PRIMARY / 12 ADDITIONAL
          </p>
        </div>

        <div ref={gridRef} className={`relative transition-all duration-700 ease-out delay-150 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(to right, var(--foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)",
          backgroundSize: "40px 40px"
        }} aria-hidden="true" />

          <div className="relative grid grid-cols-2 md:grid-cols-4 border-t border-l border-border">
            {partners.map((partner, i) => <div key={i} data-index={i} className="group relative border-r border-b border-border aspect-[3/2] flex flex-col items-center justify-center px-6 py-10 md:px-12 md:py-14 transition-all duration-500 hover:bg-accent">
                <span className="absolute top-2 left-2 font-mono text-[9px] tracking-widest text-secondary/30">
                  {String(i + 1).padStart(2, "0")}
                </span>

                <div className="font-default font-semibold text-base md:text-lg tracking-tighter text-foreground transition-all duration-500 group-hover:text-primary">
                  {partner.name}
                </div>

                <div className="absolute bottom-4 left-0 right-0 text-center font-mono text-[10px] tracking-[0.18em] text-secondary opacity-0 translate-y-1 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                  {partner.descriptor}
                </div>
              </div>)}
          </div>

          <div className="flex items-center justify-between mt-6 font-mono text-[10px] tracking-widest text-secondary/50">
            <span>GRID / 4 X 2</span>
            <span>STATUS: ACTIVE</span>
            <span>REV. 2024.11</span>
          </div>
        </div>

        <div ref={marqueeRef} className={`mt-20 md:mt-24 transition-all duration-700 ease-out delay-300 ${marqueeVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="flex items-center gap-4 mb-5">
            <span className="font-mono text-[10px] tracking-[0.25em] text-secondary/60">
              + MATERIAL NETWORK
            </span>
            <div className="flex-1 h-px bg-border" />
          </div>

          <div className="relative overflow-hidden">
            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-background to-transparent" />
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-background to-transparent" />

            <div className="flex animate-[marquee_45s_linear_infinite] whitespace-nowrap">
              {[...additionalPartners, ...additionalPartners].map((name, i) => <div key={i} data-index={i} className="flex items-center gap-10 px-10 font-mono text-sm tracking-[0.25em] text-foreground/30">
                  <span>{name}</span>
                  <span className="text-foreground/15">/</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}